import React from 'react';
import proptypes from 'prop-types';
import NumberCircle from './NumberCircle';
import styles from './postboost.module.scss';

const PostBoostBenefit = ({ number, benefit }) => {
  return (
    <div className={styles.boostBenefit}>
      <NumberCircle number={number}></NumberCircle>
      <p className={'fs-20 ' + styles.noMargin}>{benefit}</p>
    </div>
  );
};

PostBoostBenefit.propTypes = {
  number: proptypes.number,
  benefit: proptypes.string,
};
export default PostBoostBenefit;
